import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import CandidateAxisPill from "../CandidateAxisPill";

const CandidateDecisionHistory = ({ items }) => {
    const { t } = useTranslation("models");

    return (
        <VStack align="stretch" gap={3}>
            <Text fontSize="xs" color="gray.500">{t("decisionHistory.hint")}</Text>
            {items.length === 0 && <Text fontSize="sm" color="gray.500">{t("decisionHistory.empty")}</Text>}
            {items.map(r => (
                <Box key={r.id} bg="white" border="1px solid" borderColor="gray.200" borderRadius={12} p={4}>
                    <VStack align="stretch" gap={1}>
                        <HStack gap={2} flexWrap="wrap">
                            <CandidateAxisPill axis="humanDecision" value={r.previousDecision} />
                            <Text fontSize="sm" color="gray.400">→</Text>
                            <CandidateAxisPill axis="humanDecision" value={r.decision} />
                            {r.divergesFromAi && (
                                <Text fontSize="11px" fontWeight={600} bg="red.50" color="red.700" px={2.5} py={0.5} borderRadius="12px">
                                    {t("decisionHistory.divergent")}
                                </Text>
                            )}
                        </HStack>
                        <Text fontSize="xs" color="gray.500">
                            {dayjs(r.decidedAt).format("DD.MM.YYYY HH:mm")} · {r.userName ?? t("decisionHistory.automatic")}
                        </Text>
                        {r.reason && <Text fontSize="sm" color="gray.700">{r.reason}</Text>}
                        <HStack gap={2}>
                            <Text fontSize="xs" color="gray.500">{t("decisionHistory.aiThen")}:</Text>
                            <CandidateAxisPill axis="aiRecommendation" value={r.aiRecommendation} />
                            {r.aiScorePercent != null && <Text fontSize="xs" color="gray.500">{Math.round(r.aiScorePercent)}%</Text>}
                        </HStack>
                    </VStack>
                </Box>
            ))}
        </VStack>
    );
};

export default CandidateDecisionHistory;
